"use client";

import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";

interface LanguageSwitcherProps {
  collapsed?: boolean;
}

export function LanguageSwitcher({ collapsed = false }: LanguageSwitcherProps) {
  const { language, setLanguage } = useLanguage();

  if (collapsed) {
    return (
      <div className="flex flex-col items-center gap-1">
        <Button
          variant={language === "en" ? "default" : "ghost"}
          size="sm"
          onClick={() => setLanguage("en")}
          className={`text-xs h-8 w-8 p-0 transition-all duration-200 ${
            language === "en" 
              ? "bg-gradient-to-r from-rose-500 to-pink-600 hover:from-rose-600 hover:to-pink-700 text-white shadow-lg shadow-rose-500/30" 
              : "text-gray-400 hover:text-white hover:bg-gray-700/70 border border-transparent hover:border-gray-600/50"
          }`}
          title="English"
        >
          EN
        </Button>
        <Button
          variant={language === "zh" ? "default" : "ghost"}
          size="sm"
          onClick={() => setLanguage("zh")}
          className={`text-xs h-8 w-8 p-0 transition-all duration-200 ${
            language === "zh" 
              ? "bg-gradient-to-r from-rose-500 to-pink-600 hover:from-rose-600 hover:to-pink-700 text-white shadow-lg shadow-rose-500/30" 
              : "text-gray-400 hover:text-white hover:bg-gray-700/70 border border-transparent hover:border-gray-600/50"
          }`}
          title="中文"
        >
          中
        </Button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5 bg-gray-900/80 rounded-lg p-1 w-full justify-center border border-gray-700/50">
      <Button
        variant={language === "en" ? "default" : "ghost"}
        size="sm"
        onClick={() => setLanguage("en")}
        className={`text-xs flex-1 h-9 transition-all duration-200 ${
          language === "en" 
            ? "bg-gradient-to-r from-rose-500 to-pink-600 hover:from-rose-600 hover:to-pink-700 text-white shadow-lg shadow-rose-500/30" 
            : "text-gray-400 hover:text-white hover:bg-gray-700/70 border border-transparent hover:border-gray-600/50"
        }`}
      >
        English
      </Button>
      <Button
        variant={language === "zh" ? "default" : "ghost"}
        size="sm"
        onClick={() => setLanguage("zh")}
        className={`text-xs flex-1 h-9 transition-all duration-200 ${
          language === "zh" 
            ? "bg-gradient-to-r from-rose-500 to-pink-600 hover:from-rose-600 hover:to-pink-700 text-white shadow-lg shadow-rose-500/30" 
            : "text-gray-400 hover:text-white hover:bg-gray-700/70 border border-transparent hover:border-gray-600/50"
        }`}
      >
        中文
      </Button>
    </div>
  );
}
